module.exports = __webpack_public_path__ + "img/icon_stopwatch.ec631eb9.svg";